import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'address3Separator'
})
export class Address3SeparatorPipe implements PipeTransform {

  constructor() {}

  transform(value: any): string {


    if (!Array.isArray(value))
      return '';

    const array = Array.from(value)
      .sort((a, b) => a.address3.localeCompare(b.address3))
      .map(x => { return x.address3 })

    return this.arrayToSentence(array);
  }

  arrayToSentence(arr: string[]): string {
    if (arr.length === 0) {
      return '';
    } else if (arr.length === 1) {
      return arr[0];
    } else if (arr.length === 2) {
      return `${arr[0]} y ${arr[1]}`;
    } else {
      const lastElement = arr.pop();
      return `${arr.join(', ')}, y ${lastElement}`;
    }
  }

}
